import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { UserAddIcon } from '../../../../../common/icons';

import './AddDriver.css';

@inject('translationsStore')
@observer
export default class AddDriver extends Component {
  render() {
    const { visible, translationsStore, onClick } = this.props;
    return (
      <Fragment>
        {!!visible && (
          <div className="AddDriver" onClick={onClick}>
            <div>
              <UserAddIcon width="28" height="28" />
            </div>
            <div>{translationsStore.translate('driversManager.addDriver.buttonLabel')}</div>
          </div>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/DriversManagerDashboard/SelectableDrivers/AddDriver/AddDriver.js